import Constants from "../constants";
import ObjectAssign from "object-assign";
import ParseValidation from "../../../../../helpers/parse-validation";

const initialState = {
    loading: false,
    error: undefined,
    hasError: {},
    help: {},
    accountId: undefined,
    options: [],
    current: {},
    log: [],
    userFarms: [],
    permissionsEndpoint: "",
    newFarm: "",
};
const reducer = function (state = initialState, action) {
    if (action.type === Constants.GET_DETAILS_RESPONSE) {
        const stateUpdates = ObjectAssign({}, initialState);

        stateUpdates.accountId = action.response._id;
        stateUpdates.options = state.options;

        if (action.response.hasOwnProperty("farms")) {
            stateUpdates.userFarms = action.response.farms.reverse();
        }

        return ObjectAssign({}, stateUpdates);
    }

    if (action.type === Constants.DELETE_ACCOUNT_FARM_RESPONSE) {
        const stateUpdates = ObjectAssign({}, initialState);

        stateUpdates.accountId = action.response._id;
        stateUpdates.options = state.options;

        if (action.response.hasOwnProperty("farms")) {
            stateUpdates.userFarms = action.response.farms.reverse();
        }

        return ObjectAssign({}, stateUpdates);
    }

    if (action.type === Constants.GET_PERMISSIONS_URL_RESPONSE) {
        return ObjectAssign({}, state, {
            permissionsEndpoint: action.response.permissionsEndpoint,
        });
    }

    if (action.type === Constants.GET_FARM_OPTIONS_RESPONSE) {
        const stateUpdates = {};

        if (action.response.hasOwnProperty("data")) {
            stateUpdates.options = action.response.data;
        }

        return ObjectAssign({}, state, stateUpdates);
    }

    if (action.type === Constants.NEW_FARM) {
        return ObjectAssign({}, state, {
            loading: true,
            newFarm: action.request.data.farm,
        });
    }

    if (action.type === Constants.NEW_FARM_RESPONSE) {
        const validation = ParseValidation(action.response);
        const stateUpdates = {
            loading: false,
            showSaveSuccess: !action.err,
            error: validation.error,
            hasError: validation.hasError,
            help: validation.help,
        };

        if (action.response.hasOwnProperty("farms")) {
            stateUpdates.userFarms = action.response.farms.reverse();
        }

        return ObjectAssign({}, state, stateUpdates);
    }

    if (action.type === Constants.HIDE_FARM_SAVE_SUCCESS) {
        return ObjectAssign({}, state, {
            showSaveSuccess: false,
        });
    }

    return state;
};

export default reducer;
